const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp']

const FILE_ICON_MAP = {
    pdf: 'file-earmark-pdf',
    doc: 'file-earmark-word',
    docx: 'file-earmark-word',
    xls: 'file-earmark-excel',
    xlsx: 'file-earmark-excel',
    zip: 'file-earmark-zip',
    rar: 'file-earmark-zip',
    txt: 'file-earmark-text',
    csv: 'file-earmark-spreadsheet'
}

export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${Math.round(bytes / Math.pow(k, i) * 100) / 100} ${sizes[i]}`
}

export function getFileExtension(filename) {
    return filename.split('.').pop().toLowerCase()
}

export function isImage(filename) {
    return IMAGE_EXTENSIONS.includes(getFileExtension(filename))
}

export function getFileIcon(filename) {
    return FILE_ICON_MAP[getFileExtension(filename)] ?? 'file-earmark'
}

export function downloadFile(url, filename, toast) {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    toast?.({
        title: 'Успех',
        message: 'Файл успешно скачен!',
        variant: 'success'
    })
}